/** SVG viewBox width; scale to screen ≈ size / this value. */
export const COMMERCIUM_CART_VIEWBOX_WIDTH = 200

/** SVG viewBox height (200×140 artboard). */
export const COMMERCIUM_CART_VIEWBOX_HEIGHT = 140

/** Canvas bleed so round stroke caps and tilt are not clipped. */
export const COMMERCIUM_CART_VIEWBOX_PAD_X = 18
export const COMMERCIUM_CART_VIEWBOX_PAD_Y = 16

export const COMMERCIUM_CART_VIEWBOX_TOTAL_WIDTH =
  COMMERCIUM_CART_VIEWBOX_WIDTH + COMMERCIUM_CART_VIEWBOX_PAD_X * 2

export const COMMERCIUM_CART_VIEWBOX_TOTAL_HEIGHT =
  COMMERCIUM_CART_VIEWBOX_HEIGHT + COMMERCIUM_CART_VIEWBOX_PAD_Y * 2

/** Display height for a given logo width so the mark is not stretched. */
export function commerciumCartDisplayHeight(size: number): number {
  return Math.round((size * COMMERCIUM_CART_VIEWBOX_HEIGHT) / COMMERCIUM_CART_VIEWBOX_WIDTH)
}

const SPOKE_STROKE_DESIGN = 2.4
/** Target minimum spoke thickness on screen (CSS px). */
const SPOKE_MIN_SCREEN_PX = 1.5
/** Below this display size, use stronger spoke opacity on light backgrounds. */
export const COMMERCIUM_CART_SPOKE_BOOST_SIZE = 80
/** Hide wheel spokes when they cannot render crisply. */
export const COMMERCIUM_CART_SPOKE_MIN_SIZE = 72

export function commerciumCartSpokeStrokeWidth(size: number): number {
  const normalized =
    (SPOKE_MIN_SCREEN_PX * COMMERCIUM_CART_VIEWBOX_WIDTH) / Math.max(1, size)
  return Math.max(SPOKE_STROKE_DESIGN, Math.round(normalized * 10) / 10)
}

export function commerciumCartSpokeColor(size: number, onDark = false): string {
  if (onDark) {
    return 'rgba(255,255,255,.85)'
  }
  const alpha = size < COMMERCIUM_CART_SPOKE_BOOST_SIZE ? 0.85 : 0.62
  return `rgba(255,255,255,${alpha})`
}

export function commerciumCartShowSpokes(size: number): boolean {
  return size >= COMMERCIUM_CART_SPOKE_MIN_SIZE
}
